import * as Icons from "lucide-react";
import { WHY_US, STEPS } from "@/lib/constants";
import { useReveal } from "@/hooks/use-reveal";

export default function WhyChooseUs() {
  const r = useReveal();
  return (
    <section className="py-20 sm:py-24 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={r.ref} className={r.className}>
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div>
              <span className="text-sm font-semibold uppercase tracking-widest text-[#0E7490]">Why Choose Us</span>
              <h2 className="mt-2 font-display text-3xl sm:text-4xl md:text-5xl font-bold text-[#111827] leading-tight">
                A friendly counter <span className="text-[#0057B8]">right by the toll plaza</span>
              </h2>
              <p className="mt-4 text-[#6B7280] text-base sm:text-lg">
                Skip confusing apps and long queues. Get direct assistance from our team, with clear pricing and clear documents.
              </p>

              <div className="mt-8 grid sm:grid-cols-2 gap-4">
                {WHY_US.map((w) => {
                  const Ic = Icons[w.icon] || Icons.CheckCircle2;
                  return (
                    <div key={w.title} className="flex gap-3 bg-white rounded-xl p-4 border border-[#E2E8F0]">
                      <div className="w-10 h-10 rounded-lg bg-[#F59E0B]/15 text-[#B45309] grid place-items-center shrink-0">
                        <Ic className="w-5 h-5" />
                      </div>
                      <div>
                        <div className="font-semibold text-[#111827]">{w.title}</div>
                        <div className="text-sm text-[#6B7280] mt-0.5">{w.desc}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="relative">
              <span className="text-sm font-semibold uppercase tracking-widest text-[#0E7490]">How it Works</span>
              <h3 className="mt-2 font-display text-2xl sm:text-3xl font-bold text-[#111827]">Three simple steps</h3>

              <div className="mt-6 space-y-4">
                {STEPS.map((s, i) => {
                  const Ic = Icons[s.icon] || Icons.Circle;
                  return (
                    <div key={s.n} className="relative bg-white border border-[#E2E8F0] rounded-2xl p-5 pl-6 shadow-sm hover:shadow-md transition-shadow">
                      <div className="flex items-start gap-4">
                        <div className="shrink-0">
                          <div className="w-14 h-14 rounded-xl bg-[#0057B8] text-white grid place-items-center font-display text-lg font-bold">
                            {s.n}
                          </div>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <Ic className="w-4 h-4 text-[#0E7490]" />
                            <div className="font-display text-lg font-semibold text-[#111827]">{s.title}</div>
                          </div>
                          <div className="text-[#6B7280] mt-1">{s.desc}</div>
                        </div>
                      </div>
                      {i < STEPS.length - 1 && (
                        <div className="absolute left-[35px] -bottom-4 h-4 w-px bg-[#E2E8F0]" />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
